import { defineMessages } from 'react-intl';

export default defineMessages({
  yourBorrows: 'Your borrows',
  borrowed: 'Borrowed',
  APYType: 'APY Type',
});
